/**
 * Chat attachments are served under /media/ on the same host as the SPA (e.g. nginx :8080).
 * Normalize API URLs so wrong absolute origins (e.g. http://localhost/media/... without port)
 * still load in the browser.
 */
export function resolveAttachmentMediaUrl(fileUrl: string | null | undefined): string {
  if (!fileUrl?.trim()) return ""
  const raw = fileUrl.trim()
  if (raw.startsWith("blob:")) {
    return raw
  }
  if (raw.startsWith("/")) {
    if (typeof window === "undefined") return raw
    return `${window.location.origin}${raw}`
  }
  try {
    const parsed = new URL(raw)
    if (parsed.pathname.startsWith("/media/")) {
      if (typeof window === "undefined") return raw
      return `${window.location.origin}${parsed.pathname}${parsed.search}`
    }
  } catch {
    /* ignore */
  }
  return raw
}
